if (!customElements.get('tank-video-gallery')) {
  customElements.define('tank-video-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-video-track]');
      const nav = this.querySelector('[data-video-nav]');
      const prev = this.querySelector('[data-video-prev]');
      const next = this.querySelector('[data-video-next]');
      const videos = [...this.querySelectorAll('video')];
      const updateNav = () => {
        const max = track.scrollWidth - track.clientWidth;
        nav.hidden = max < 2;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const scroll = direction => track.scrollBy({
        left: direction * track.clientWidth * .85,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      prev.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', updateNav, { passive: true });
      this.resizeObserver = new ResizeObserver(updateNav);
      this.resizeObserver.observe(track);
      videos.forEach(video => {
        const button = video.parentElement.querySelector('[data-video-play]');
        button.hidden = false;
        button.addEventListener('click', () => {
          button.hidden = true;
          video.play().catch(() => { button.hidden = false; });
        });
        video.addEventListener('play', () => {
          button.hidden = true;
          videos.forEach(other => { if (other !== video) other.pause(); });
        });
        video.addEventListener('ended', () => { button.hidden = false; });
      });
      updateNav();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  });
}
